import React                    from 'react';
import { Observe }                   from 'rewire-core';
import { WithStyle, withStyles }     from 'rewire-ui';
import Typography                    from '@material-ui/core/Typography';
import { Theme }                     from '@material-ui/core/styles';
import Loader                        from '../ui/Loader';
import TimecardTestSummaryView       from './TimecardTestSummaryView';
import TimecardTestEditTimecardsView from './editTimecard/TimecardTestEditTimecardsView';
import timecardTestListModel         from './TimecardTestListModel';
import timecardTestModel             from './TimecardTestModel';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative'
  },
  noResults: {
    margin: '10px'
  },
});

interface ITimecardTestProps {
  classes?: any,
}

type TimecardTestProps = WithStyle<ReturnType<typeof styles>, ITimecardTestProps>;

class TimecardTestView extends React.PureComponent<TimecardTestProps> {
  constructor(props: TimecardTestProps) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe render={() => (
          <Loader loading={timecardTestModel.isLoading}>
            <Observe render={() => (
              timecardTestModel.hasTest
                ? < >
                    {timecardTestModel.isView('Summary')
                      ? <TimecardTestSummaryView />
                      : <TimecardTestEditTimecardsView />
                    }
                  </>
                : timecardTestListModel.testCount
                    ? <div>
                        <Typography className={this.props.classes.noResults} variant='h3'>No test selected</Typography>
                        <Typography className={this.props.classes.noResults} variant='h5'>Select a test from the list to view it</Typography>
                      </div>
                    : <div>
                        <Typography className={this.props.classes.noResults} variant='h3'>No results available</Typography>
                        <Typography className={this.props.classes.noResults} variant='h5'>Return to search for tests that meet your criteria</Typography>
                      </div>
            )} />
          </Loader>
        )} />
      </div>
    );
  }
}

export default withStyles<ITimecardTestProps, unknown>(styles, TimecardTestView);
